import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        orderTrackingByApi: {
            width: '30%',
        },
    }
})

export default useStyles
